// Only needed for "useBuiltIns": "entry"
// import '@babel/polyfill'
import './scss/main.scss'
import loadPolyfills from './js/loadpolyfills'
import MainNavigation from './js/mainnavigation'

loadPolyfills().then(() => {
    const mainNavigation = new MainNavigation() // eslint-disable-line no-unused-vars
})
